export const APP_STATE_RECEIVED = "APP_STATE_RECEIVED";
export const SET_LOCAL_APP_STATE = "SET_LOCAL_APP_STATE";
